import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaEventsUtility from "global/sparta-events-utility";

















const EVENTS = {
  FOOTNOTES_REBUILD: 'FOOTNOTES_REBUILD.footnoteUtility',
  RULE_QUEUECOMPLETE: 'RULE-QUEUECOMPLETE.spartaRulesUtility',
};

class footnoteUtility {
  get EVENTS() {
    return EVENTS;
  }

  constructor() {
    this.$footnoteSection = null;
    this.$footnoteLinks = null;
    this.footnoteObj = {};
    this.footnoteOrder = [];

    this.init();
  }


  init() {
    this.$footnoteSection = $('.spa-footnotes-section');


    if (!this.$footnoteSection.length) return;


    this.getFootnotes();


    this.updateFootnoteSection();


    this.updateFootnoteLinks();


    this.setupEventListeners();


    const checkForRebuild = this.checkForRebuild.bind(this);

    spartaEventsUtility.sub(this.EVENTS.FOOTNOTES_REBUILD, () => {
      checkForRebuild();
    }, true);

    spartaEventsUtility.sub(this.EVENTS.RULE_QUEUECOMPLETE, () => {
      $('[data-sparta-container]').on('webkitAnimationEnd oanimationend msAnimationEnd animationend',
        checkForRebuild());
    }, true);

    spartaEventsUtility.pub('FOOTNOTE_UTIL_RAN', true);
  }







  getFootnotes() {
    const footnoteObj = {};
    const footnoteOrder = [];
    let footnoteIndex = 0;

    this.$footnoteLinks = $('a[data-footnote]');

    this.$footnoteLinks.each(function footnoteLink() {
      const $this = $(this);
      const thisFn = $this.data() || {};

      if (typeof footnoteObj[thisFn.footnote] === 'undefined') {
        thisFn.footnoteIndex = footnoteIndex;
        thisFn.footnoteLinkId = $this.attr('id');
        footnoteObj[thisFn.footnote] = thisFn;
        footnoteOrder.push(thisFn.footnote);
        footnoteIndex += 1;
      }
    });


    this.footnoteObj = footnoteObj;
    this.footnoteOrder = footnoteOrder;
  }





  updateFootnoteSection() {
    let newFootnotes = '<ol>';
    let counter = 0;


    const ariaLabelBack = this.$footnoteSection.data('ariaLabelBack') ? ` aria-label="${this.$footnoteSection.data('ariaLabelBack')}"` : '';

    this.footnoteOrder.forEach((fn) => {
      counter += 1;

      const backToContentLink = this.$footnoteSection.data('backContent') ? ` <a href="#${this.footnoteObj[fn].footnoteLinkId}"${ariaLabelBack} class="spa-footnote-back">${this.$footnoteSection.data('backContent')}</a>` : '';

      newFootnotes += `<li value="${counter}" id="ftn_${this.footnoteObj[fn].footnote}_content"><span>${this.footnoteObj[fn].footnoteContent}</span>${backToContentLink}</li>`;
    }, this);

    newFootnotes += '</ol>';


    this.$footnoteSection.html(newFootnotes);
  }





  updateFootnoteLinks() {
    for (let i = 0; i < this.footnoteOrder.length; i += 1) {
      const index = i + 1;
      const $thisFn = $(`a[data-footnote=${this.footnoteObj[this.footnoteOrder[i]].footnote}]`);
      const newContent = `<span class="ada-hidden">Footnote </span>${index}`;

      $thisFn.find('span.spa-footnote-order').html(newContent);
    }
  }






  setupEventListeners() {
    $('body').on('click.footnoteLink', 'a[id^="ftn_"]', function footnoteLinkClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const footnoteLink = this;
      const $target = $(`#ftn_${footnoteLink.dataset.footnote}_content`);
      const $panelToggle = $('[data-toggle="#panel-legal"]');
      const $panelToggleHeader = $panelToggle.parents('.spa-toggle-heading');



      let offset = 60;
      let targetOffset = $target.offset();
      targetOffset = targetOffset ? targetOffset.top - offset : 0;
      let stickyOffset = 0;

      if (!$panelToggleHeader.hasClass('active')) {
        $panelToggle.find('> span').addClass('active');
        $panelToggleHeader.addClass('active');

        $('#panel-legal').addClass('active').slideDown({
          complete: function stickySlideDownComplete() {


            offset = 60;

            stickyOffset = footnoteUtility.getStickyOffset();
            offset = stickyOffset > offset ? stickyOffset : offset;
            targetOffset = $target.offset();
            targetOffset = targetOffset ? targetOffset.top - offset : 0;

            footnoteUtility.scrollToTarget($target, targetOffset);
          },
        });
      } else {
        stickyOffset = footnoteUtility.getStickyOffset();
        offset = stickyOffset > offset ? stickyOffset : offset;
        targetOffset = $target.offset();
        targetOffset = targetOffset ? targetOffset.top - offset : 0;
        footnoteUtility.scrollToTarget($target, targetOffset);
      }
    });


    $('[data-sparta-container]').on('blur.footnoteBack', '.spa-footnote-back', () => {
      $('.spa-footnote-back').css('display', 'none');
      $('.spa-footnotes-section li').removeAttr('tabindex');
    });

    $('body').on('click.footnoteBack', '.spa-footnote-back', function footnoteBackClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const $backLink = $(this);
      const $footnoteLink = $($backLink.attr('href'));

      if ($footnoteLink.is(':visible')) {
        let linkOffset = $footnoteLink.offset();
        linkOffset = linkOffset ? linkOffset.top - footnoteUtility.getStickyOffset() : 0;
        footnoteUtility.scrollToTarget($footnoteLink, linkOffset);
      }
    });


    $('body').on('focus.footnote', '.spa-footnotes-section li', function footnoteFocus() {
      const $backLink = $(this).find('.spa-footnote-back');
      const $footnoteLink = $($backLink.attr('href'));

      if ($footnoteLink.is(':visible')) {
        $backLink.css('display', 'inline');
      }
    });
  }

  checkForRebuild() {
    const oldLinks = this.$footnoteLinks;
    let newLinks = [];

    if (!oldLinks) {
      this.rebuildFootnotes();
    } else {
      newLinks = $('a[data-footnote]');

      if (newLinks.length !== oldLinks.length) {
        this.rebuildFootnotes();
      } else {
        for (let i = 0; i < newLinks.length; i += 1) {
          if (newLinks[i] !== oldLinks[i]) {
            this.rebuildFootnotes();
            return;
          }
        }
      }
    }
  }

  rebuildFootnotes() {

    this.getFootnotes();


    this.updateFootnoteSection();


    this.updateFootnoteLinks();
  }

  static getStickyOffset() {
    let stickyOffset = 0;
    $('.spa-sticky').each(function spaStickyOffset() {
      stickyOffset += $(this).outerHeight();
    });
    return stickyOffset;
  }

  static scrollToTarget($el, targetOffset) {
    $('html, body').animate({
      scrollTop: targetOffset,
    }, 250, () => {
      if (($el).is('.spa-footnotes-section li')) {
        $el.attr('tabindex', '-1').focus();
      } else {
        $el.focus();
      }
    });
  }





  dynamicFootnotes() {











































































  }
}

export default new footnoteUtility();
